import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { hideNotificationsDrawer } from '@/data/notifications/actions';
import ActionButton from '@/notifications/components/ActionButton';
import { CONTAINER_CLASSNAME, NotifyItem } from '@/notifications/components/NotifyItem';
import notificationIcon from '@/rippling/assets/img/rippling-notification-icon.png';
import { posthogCapture } from '@/shared/vendor/posthog';
import { useWiwDispatch } from '@/store';
import '@/rippling/assets/styles/RipplingNotification.scss';

interface RipplingNotificationProps {
  closeCrossSell: () => void;
}

const RipplingNotification = ({ closeCrossSell }: RipplingNotificationProps) => {
  const history = useHistory();
  const dispatch = useWiwDispatch();

  useEffect(() => {
    posthogCapture('rippling_xs.alert_bell.viewed');
  }, []);

  const handleSeeMyOffer = () => {
    history.push({
      pathname: '/splash/rippling',
      search: 'utm_source=wiw-app&utm_medium=link&utm_campaign=rippling_alert_bell_notification',
    });
    dispatch(hideNotificationsDrawer());
    closeCrossSell();
  };

  const actions = [
    <ActionButton
      key="see-my-offer"
      title="Learn more"
      type="green"
      click={handleSeeMyOffer}
      requestType="rippling_xs.alert_bell.view_offer"
    />,
    <ActionButton
      key="no-thanks"
      title="No thanks"
      type="gray"
      click={closeCrossSell}
      requestType="rippling_xs.alert_bell.no_thanks"
    />,
  ];

  return (
    <div className={`notifications-rippling ${CONTAINER_CLASSNAME}`}>
      <NotifyItem
        title="Add payroll"
        description="Get 6 FREE months of payroll through When I Work's preferred partner, Rippling."
        icon={<img src={notificationIcon} aria-hidden />}
        actions={actions}
      />
    </div>
  );
};

export default RipplingNotification;
